<template>
    <div class="container">
            <div class="row" >
                <back-container link="/home"></back-container>
             </div>
             <div class="center" v-if="loading">
                <loading ></loading>
            </div>
            <div class="row" v-else>
                <div class="col s4" v-for="item in townships"> 
                        <router-link :to="{name:'Volunteer',params:{'township_id':item.id}}">
                            <div class="card card-content">
                                <p>{{ item.name }}</p>
                            </div>
                        </router-link>
                </div>
            </div>
             
               
            
           
    </div>
</template>
<script>
import Loading from '@/components/Partials/Loading.vue';
export default {
    mounted()
    {
        this.$store.dispatch("getTownships");
    },
    components: 
    {
        "loading":Loading,
    },
    computed: 
    {
        loading()
        {
            return this.$store.getters.initial_townships_loading;   
        },
        townships()
        {
            return this.$store.getters.initial_townships;
        }
    }
    
    
}
</script>
<style scoped>
        .container 
    {
        padding-top:30px;
    }


 .icons 
{
    font-size:50px;
    color:var(--card-icon-color) !important;
}

 .card-content
{
    padding-top:15px;
    padding-bottom:15px;
    text-align: center;
    font-size:16px;
}

 .card
 {
     border-radius: 20px;
     border-left:20px solid var(--card-icon-color) !important;
     
 }


 .card:hover 
{
    border-right:20px solid var(--card-icon-color) !important;
    transition:2s;
}

.card:hover .forward
{
    color:var(--card-icon-color) !important;
    transition: 2s;
}




 .card-content h6 
{
    font-size:22px;
}
   
</style>